import React, { FC } from 'react';
import { useEventsStatusesQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface SportingEventsStatus extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const SportingEventsStatus: FC<SportingEventsStatus> = ({ label, error, control, name, rules }) => {
  const { data } = useEventsStatusesQuery();
  return (
    <Select
      label={label}
      data={(data && data.dirSportingEventStatuses) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default SportingEventsStatus;
